import "./sec3.css";
import Redlining from "./redlining-components/Redlining";
import Area from "./area-components/Area";
import { useRef, MutableRefObject, useState, useReducer } from "react";
import { HOLCGrade } from "./redlining-components/RedliningMap";

const Sec3 = () => {
  const selectionMap: MutableRefObject<Record<string, HOLCGrade>> = useRef({});
  const [showAreaMap, setShowAreaMap] = useState(false);
  
  const markAsCompleted = () => {
    if (!showAreaMap) {
      setShowAreaMap(true);
    }
  };

  return (
    <div className="sec3-section">
      <span>
        Redlining in Boston historically involved discriminatory lending
        practices that denied
      </span>
      <span>
        mortgages and insurance to residents, primarily in African American
        neighborhoods,
      </span>
      <span>based on racially biased evaluations of neighborhood risk.</span>

      <span className="extraPad">
        {" "}
        How would you have rated different neighborhoods?
      </span>

      
      <div id="redlining">
        <Redlining selectionMap={selectionMap} />
      </div>

      {!showAreaMap && (
        <button className="button-style" onClick={markAsCompleted}>Reveal the Original Redlining Map</button>
      )}

      {showAreaMap && (
        <div id="area">
          <Area selectionMap={selectionMap} />
        </div>
      )}
    </div>
  );
};

export default Sec3;


